import script from "./ProfileSpouseRelationship.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileSpouseRelationship.vue?vue&type=script&lang=ts&setup=true"

import "./ProfileSpouseRelationship.vue?vue&type=style&index=0&id=7d3d51a2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d3d51a2"]])

export default __exports__